import { mapGetters, mapActions } from "vuex";

export const mapHelper = {
  ...mapGetters([
    "getLoadingSpin",
    "getDisabledButton",
    "getEmail",
    "getUserID",
    "getUserName",
    "getFirstName",
    "getFullName",
    "getAddress",
    "getCellphone",
    "getTelephone",
    "getYourIp",
    "getMultiOpt",
    "getTextRecover",
    "getTextLogin",
    "getEntity",
    "getProduct",
    "getPrice",
    "getButtonWallet",
    "getButtonOnline",
    "getBalanceClient",
    "getAmountToSet",
    "getConfirmCreditWallet",
    "getCloseSetCreditWallet",
    "getBanckAccount",
    "getCloseSetTransWallet",
    "getAmountToSetWallet",
    "getConfirmTransWallet",
    "getNameToTransfer",
    "getBankToTransfer",
    "getTransactionToStoryWallet",
    "getDataSetAfter",
    "getOptMenu",
    "getProductToDisplay",
    "getDisplayMcx",
    "getDisplayWallet",
    "getRefOrigin",
    "getReference",
    "getPayType",
    "getCellphoneH1",
    "getAllCategoryProductToDisplay",
    "getAllCTransactions",
    "getAvatarClient",
    "getDescriptionUnitel",
  ]),
  ...mapActions({
    setLogout: "logout"
  })
};
